// CategoryList.tsx
import React, { useEffect, useState } from 'react';
import CategoryEditor from './CategoryEditor'; // Assuming CategoryEditor is in the same directory
import { CategoryCalcNode } from './AlternativesEditor';
import { DragDropContext, Draggable, Droppable, DropResult } from '@hello-pangea/dnd';
import styled from 'styled-components';


interface CategoryListProps {
  flyerLocale: string;
  categories: CategoryCalcNode[];
  onReorder: (categories: CategoryCalcNode[]) => void;
  onChange: (update: CategoryCalcNode) => void;
}

const CategoryList: React.FC<CategoryListProps> = ({ flyerLocale, categories, onReorder, onChange }) => {
  const [localCategories, setLocalCategories] = useState(categories);

  useEffect(() => {
    setLocalCategories(categories);
  }, [categories])

  const handleOnDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const items = Array.from(localCategories);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setLocalCategories(items);
    onReorder(items);
  };

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable droppableId="categories">
        {(provided) => (
          <CategoryListContainer {...provided.droppableProps} ref={provided.innerRef}>
            {localCategories.map((category, index) => (
              <Draggable key={category.id} draggableId={category.id} index={index}>
                {(provided) => (
                  <CategoryItem
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                  >
                    <DragHandle {...provided.dragHandleProps}>
                      &#x283F;
                    </DragHandle>
                    <CategoryEditor 
                      flyerLocale={flyerLocale} 
                      category={category}
                      onChange={(update) => onChange(update)}
                    />
                  </CategoryItem>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </CategoryListContainer>
        )}
      </Droppable>
    </DragDropContext>
  );
};

const CategoryListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  width: 100%;
  background-color: var(--control-bg-color);
  border: 1px solid var(--border-color); 
  border-radius: 0.25rem;
`;

const DragHandle = styled.div`
  cursor: grab;
  margin-right: 10px;

  &:active {
    cursor: grabbing;
  }
`;

export default CategoryList;
